import { useEffect } from 'react';
import { ExternalLink, X } from 'lucide-react';

export const PAPERS = {
  village: { name: 'The Village Star-Revue', url: 'https://book533220.publuu.com' },
  redhook: { name: 'Red Hook Star-Revue', url: 'https://book266892.publuu.com' },
} as const;
export type PaperKey = keyof typeof PAPERS;

/** Full-screen overlay showing a paper's Publuu bookshelf. */
export function PaperReader({ paper, onClose }: { paper: PaperKey; onClose: () => void }) {
  const p = PAPERS[paper];
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-0 sm:p-6" role="dialog" aria-modal="true" aria-label={`${p.name} — read the paper`} onClick={onClose}>
      <div className="flex h-full w-full max-w-6xl flex-col border-2 border-foreground bg-card sm:h-[90vh]" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between gap-2 border-b border-foreground px-4 py-2">
          <h2 className="truncate font-[family-name:var(--font-heading)] text-lg font-semibold">{p.name}</h2>
          <div className="flex shrink-0 items-center gap-1">
            <a href={p.url} target="_blank" rel="noreferrer" className="inline-flex min-h-11 items-center gap-1.5 px-2 text-xs font-semibold underline underline-offset-2">
              <span className="hidden sm:inline">Open in new tab</span><ExternalLink className="h-4 w-4" aria-label="Open in new tab" />
            </a>
            <button onClick={onClose} aria-label="Close" className="inline-flex h-11 w-11 items-center justify-center hover:bg-muted"><X className="h-5 w-5" /></button>
          </div>
        </div>
        <iframe src={p.url} title={`${p.name} bookshelf`} className="min-h-0 w-full flex-1 border-0 bg-muted" allow="fullscreen" allowFullScreen />
      </div>
    </div>
  );
}
